module.exports = __webpack_public_path__ + "static/media/Artboard3.8b20a02f.png";